import { ErrorPage } from '@/components/ErrorPage/ErrorPage.tsx';

export const ErrorPageNotFound = () => {
    return (
        <ErrorPage
            statusCode={404}
            message="Страница не найдена"
            buttonText="На Главную"
            redirectPath="/"
        />
    );
};
